import React, {useEffect} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react';

import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import CrossPlatformModal from '../ui-controls/CrossPlatformModal';
import Text from '../ui-controls/Text';

const InStoreShoppingModal = observer(() => {
  const {globalStore, shopSelectionStore} = useStores();

  useEffect(() => {
    if (!globalStore.acceptedInStoreOnly && shopSelectionStore.ecommerceDisabled) {
      globalStore.setInstoreOnlyVisible(true);
    }
  }, [globalStore, shopSelectionStore.ecommerceDisabled, shopSelectionStore.selectedStore]);

  return (
    <View>
      <CrossPlatformModal
        isVisible={globalStore.showInstoreOnly}
        style={{
          width: '100%',
          marginLeft: 0,
          justifyContent: 'flex-end',
          marginBottom: 0,
        }}
        hasBackdrop={true}
        backdropColor="black"
        backdropOpacity={0.56}
        animationIn="slideInUp"
        onBackButtonPress={() => {
          globalStore.acceptedInstoreShopping(true);
          globalStore.setInstoreOnlyVisible(false);
        }}>
        <View style={styles.modalView}>
          <Text style={styles.modalText}>
            {shopSelectionStore.selectedStore?.name} offers in-store shopping only.
          </Text>
          <Pressable
            style={styles.button}
            onPress={() => {
              globalStore.acceptedInstoreShopping(true);
              globalStore.setInstoreOnlyVisible(false);
            }}>
            <Text style={styles.buttonText}>OK</Text>
          </Pressable>
        </View>
      </CrossPlatformModal>
    </View>
  );
});

const styles = StyleSheet.create({
  modalView: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: 36,
    alignItems: 'center',
  },
  modalText: {
    fontSize: 16,
    marginBottom: 32,
    textAlign: 'center',
  },
  button: {
    borderRadius: 4,
    padding: 10,
    width: '50%',
    elevation: 2,
    backgroundColor: theme.colour.background.button.primary,
  },
  buttonText: {
    color: 'white',
    textAlign: 'center',
    fontSize: 16,
  },
});

export default InStoreShoppingModal;
